/* -------------------------------------------------------------------------- */
/* --------------------------- THEME : FRAMEWORKS --------------------------- */

// FRAMEWORKS : NODES_MODULES
import gsap from "gsap";
import "gsap/EasePack";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";
import ScrollSmoother from "gsap/ScrollSmoother";
gsap.registerPlugin(ScrollSmoother, ScrollTrigger, SplitText);

import Swiper from "swiper";
import {
	Autoplay,
	Pagination,
	// Thumbs,
	// EffectFade,
	// Navigation,
	// Pagination,
	Scrollbar,
} from "swiper/modules";

import intlTelInput from "intl-tel-input";
import "intl-tel-input/styles";

document.addEventListener("DOMContentLoaded", () => {
    const input = document.querySelector("#phone");

    if (!input) return;

    intlTelInput(input, {
        initialCountry: "fr",
        preferredCountries: ["fr", "be", "ch", "lu", "ca"],
        separateDialCode: true,
        loadUtils: () => import("intl-tel-input/utils"),
    });
});


/* -------------------------------------------------------------------------- */
/* ------------------------ THEME : GLOBAL VARIABLES ------------------------ */

// Default : Smooth scrolling
let scrollSmooth = false;

/* -------------------------------------------------------------------------- */
/* ------------------------- THEME : GLOBAL EVENTS -------------------------- */

// DOCUMENT READY :
document.addEventListener("DOMContentLoaded", () => {
	// remove 'page-no-js' body class
	document.body.classList.remove("page-no-js");
	gsapPreloader();
	scrollDetection(160);
	menuBurger();
	menuDropdown();
	bannerInit();
	bannerToMarquee();
	dataSrc();
	dataClone();
	dataPopin();
	dataToggle();
	initButtons();
	loadSpline();
});

// DOCUMENT RESIZED (avec ScrollTrigger)
ScrollTrigger.addEventListener("refreshInit", () => {
	gsapScrollSmootherRefresh();
	bannerToMarquee();
});

/* -------------------------------------------------------------------------- */
/* ----------------------- THEME : GLOBAL FUNCTIONS ------------------------- */

// Activation/désactivation du scroll
function scrollEnabled(bool) {
	if (bool === false || bool === true) {
		const enableScroll = bool === true;

		if (scrollSmooth) {
			scrollSmooth.paused(!enableScroll);
		}

		document.documentElement.style.overflowY = enableScroll ? "auto" : "hidden";
	}
}

// Scroll vers une ancre
const scrollToAnchor = (scrollOffset = 100) => {
	// Fonction pour gérer le défilement
	const scrollToElement = (target) => {
		const element = document.querySelector(target);
		if (element) {
			if (scrollSmooth) {
				// Avec ScrollSmoother
				scrollSmooth.scrollTo(target, true, `top ${scrollOffset}px`);
			} else {
				// Par défaut
				window.scrollTo({
					top:
						element.getBoundingClientRect().top + window.scrollY - scrollOffset,
					behavior: "smooth",
				});
			}
		}
	};

	// au chargement
	const hashInUrl = window.location.hash;
	if (hashInUrl) {
		scrollToElement(hashInUrl);
	}

	// avec un [href="#..."]
	const linksWithAnchor = document.querySelectorAll('a[href^="#"]');
	linksWithAnchor.forEach((link) => {
		link.addEventListener("click", (event) => {
			const anchorHref = link.getAttribute("href");
			if (anchorHref !== "#") {
				event.preventDefault();
				scrollToElement(anchorHref);
			}
		});
	});

	// avec un [data-scrollto]
	const dataWithScrollTo = document.querySelectorAll("[data-scrollto]");
	dataWithScrollTo.forEach((data) => {
		data.addEventListener("click", () => {
			let anchorData = data.getAttribute("data-scrollto");
			if (anchorData === "auto") {
				// Calculer la position de défilement pour 'auto'
				const autoOffset = window.innerHeight + window.scrollY - scrollOffset;
				window.scrollTo({
					top: autoOffset,
					behavior: "smooth",
				});
			} else {
				// Utiliser la valeur de data-scrollto comme cible pour scrollToElement
				scrollToElement(anchorData);
			}
		});
	});
};

// Détection du scroll sur le body
const scrollDetection = (scrollOffset = 1) => {
	let position = window.scrollY;

	if (position > scrollOffset) {
		document.body.classList.add("page-scrolled");
	} else {
		document.body.classList.remove("page-scrolled");
	}

	document.addEventListener("scroll", () => {
		// Détecter la direction du scroll
		let scroll = window.scrollY;
		// Scroll vers le bas
		if (scroll > position) {
			if (scroll < scrollOffset) {
				document.body.classList.remove("page-scrolled");
				document.body.classList.remove("page-scrolling");
			} else {
				document.body.classList.add("page-scrolling");
				document.body.classList.add("page-scrolled");
			}
		}
		// Scroll vers le haut
		else {
			document.body.classList.remove("page-scrolling");
			if (scroll < scrollOffset) {
				document.body.classList.remove("page-scrolled");
			}
		}
		// Scroll max ?
		if (scroll + window.innerHeight >= document.documentElement.scrollHeight) {
			document.body.classList.add("page-scroll-completed");
		} else {
			document.body.classList.remove("page-scroll-completed");
		}
		position = scroll;
	});
};

// Gestion du menu burger
const menuBurger = () => {
	const headerBurger = document.querySelector("#page-header-burger");
	const headerBackdrop = document.querySelector("#page-header-backdrop");

	if (headerBurger) {
		headerBurger.addEventListener("click", () => {
			if (document.body.classList.contains("page-with-fullscreenmenu")) {
				scrollEnabled(true);
				document.body.classList.remove("page-with-fullscreenmenu");
			} else {
				scrollEnabled(false);
				document.body.classList.add("page-with-fullscreenmenu");
				gsapMenuBurger();
			}
		});
	}

	if (headerBackdrop) {
		headerBackdrop.addEventListener("click", () => {
			if (document.body.classList.contains("page-with-fullscreenmenu")) {
				scrollEnabled(true);
				document.body.classList.remove("page-with-fullscreenmenu");
			} else {
				scrollEnabled(false);
				document.body.classList.add("page-with-fullscreenmenu");
			}
		});
	}
};

// Gestion des dropdowns
const menuDropdown = () => {
	const menuItemLinks = document.querySelectorAll(
		'.menu .menu__item .menu__link[href="#"]'
	);

	menuItemLinks.forEach((item) => {
		item.closest(".menu__item").classList.add("menu__item--parent");
		item.addEventListener("click", (event) => {
			event.preventDefault();
			item.closest(".menu__item").classList.toggle("menu__item--active");
		});
	});

	document.addEventListener("mouseup", (event) => {
		const activeMenuItems = document.querySelectorAll(
			".menu .menu__item.menu__item--active"
		);

		activeMenuItems.forEach((activeItem) => {
			if (
				!activeItem.isEqualNode(event.target) &&
				!activeItem.contains(event.target)
			) {
				activeItem.classList.remove("menu__item--active");
			}
		});
	});
};

// Activation/désactivation de la bannière
const bannerInit = () => {
	// Vérifie si la bannière a déjà été fermée durant cette session
	if (sessionStorage.getItem("bannerClosed") === "true") {
		return;
	}

	const pageBanner = document.querySelector("#page-banner");
	const pageBannerClose = document.querySelector("#page-banner-close");

	if (pageBanner) {
		// actualisation
		document.body.classList.add("page-with-banner");
		// bouton de fermeture
		pageBannerClose.addEventListener("click", () => {
			document.body.classList.remove("page-with-banner");

			// Enregistre en session que la bannière a été fermée
			sessionStorage.setItem("bannerClosed", "true");
		});
	}
};

// Gestion du défilement horizontal de la bannière
const bannerToMarquee = () => {
	const pageBanner = document.querySelector("#page-banner");

	if (pageBanner) {
		const bannerwrapperWidth = pageBanner.offsetWidth;
		const bannerTextWidth =
			pageBanner.querySelector(".banner__text").offsetWidth;
		if (bannerwrapperWidth > bannerTextWidth + 60) {
			pageBanner.classList.remove("page__banner--scrolling");
		} else {
			pageBanner.classList.add("page__banner--scrolling");
		}
	}
};

// Convertir les [data-src] en [src]
const dataSrc = () => {
	// Select all elements with a data-src attribute
	const srcElements = document.querySelectorAll("[data-src]");
	srcElements.forEach((element) => {
		element.setAttribute("src", element.getAttribute("data-src"));
		element.removeAttribute("data-src");
	});
};

// Cloner les éléménts [data-clone]
const dataClone = () => {
	const cloneTargets = document.querySelectorAll("[data-clone]");

	cloneTargets.forEach((cloneOriginal) => {
		const cloneValue = cloneOriginal.getAttribute("data-clone");
		const cloneParent = cloneOriginal.parentNode;

		if (!cloneParent) return;
		let cloneCount;

		if (cloneValue === "auto" || !cloneValue || cloneValue === undefined) {
			const cloneWidth = cloneOriginal.offsetWidth;
			cloneCount = Math.ceil(window.innerWidth / cloneWidth) + 1;
		} else {
			const parsedCount = parseInt(cloneValue, 10);
			if (isNaN(parsedCount) || parsedCount <= 0) return;
			cloneCount = parsedCount;
		}

		for (let i = 0; i < cloneCount; i++) {
			const clone = cloneOriginal.cloneNode(true);
			clone.removeAttribute("data-clone");
			clone.setAttribute("data-clone-child", `${i + 1}/${cloneCount}`);
			cloneParent.insertBefore(clone, cloneOriginal);
		}

		cloneOriginal.remove(); // Supprimer l'élément initial après clonage
	});
};

// Gestions des actions des [data-popin]
const dataPopin = () => {
	const popins = document.querySelectorAll("[data-popin]");

	popins.forEach((popin) => {
		popin.addEventListener("click", (event) => {
			// event.preventDefault();

			// ouvrir/fermer la popin
			const thispopinName = popin.dataset.popin;
			if (thispopinName) {
				const thispopinEl = document.querySelector(
					`.page__popin#${thispopinName}`
				);
				thispopinEl.classList.toggle("page__popin--open");
			}

			// mettre les vidéos des popins en pause
			const htmlVideoFrompopin =
				document.querySelectorAll(".page__popin video");
			if (htmlVideoFrompopin.length > 0) {
				htmlVideoFrompopin.forEach((video) => {
					video.pause();
				});
			}
		});
	});
};

// Gestions des actions des [data-toggle]
const dataToggle = () => {
	// Récupération de tous les écouteurs
	const toggleListeners = document.querySelectorAll("[data-toggle]");

	// Écouteur d'événement pour chaque écouteur
	toggleListeners.forEach((togglelistener) => {
		const toggleTargetSelector = togglelistener.dataset.toggle;
		const toggleTarget = toggleTargetSelector
			? document.querySelector(toggleTargetSelector)
			: null;

		togglelistener.addEventListener("click", (event) => {
			if (toggleTarget) {
				// event.stopPropagation();
				toggleTarget.classList.toggle("--active");
			}
		});
	});

	// Gestionnaire pour les clics hors des éléments toggle
	document.addEventListener("click", (event) => {
		toggleListeners.forEach((togglelistener) => {
			const toggleTargetSelector = togglelistener.dataset.toggle;
			const toggleTarget = toggleTargetSelector
				? document.querySelector(toggleTargetSelector)
				: null;
			if (
				toggleTarget &&
				toggleTarget.classList.contains("--active") &&
				!toggleTarget.contains(event.target) &&
				!togglelistener.contains(event.target)
			) {
				toggleTarget.classList.remove("--active");
			}
		});
	});
};


const initButtons = () => {
	const buttons = document.querySelectorAll('.e-button-base.button-primary');
	buttons.forEach((button) => {
		button.innerHTML = `<span>${button.textContent.trim()}</span>`;
	});
	const buttonsArrow = document.querySelectorAll('.e-button-base.button-arrow');
	buttonsArrow.forEach((button) => {
		button.innerHTML += `
			<span class="icon" style="translate: none; rotate: none; scale: none; transition: none; transform: translate(0%, 0px);">
				<svg class="default-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
				<path d="M0 5.24242V6.75758H9.09091L4.92424 10.9242L6 12L12 6L6 0L4.92424 1.07576L9.09091 5.24242H0Z" fill="white"></path>
				</svg>
				<svg class="hover-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 80 80">
				<path d="M0 0h80v80H0z" fill="none"></path>
				<path fill="currentColor" fill-rule="evenodd" d="M36.75 20.5a4.25 4.25 0 1 0-8.5 0v26.736a1.69 1.69 0 0 1-1.28 1.64c-2.794.7-4.099 3.913-2.584 6.361l6.5 10.5A4.25 4.25 0 0 0 34.5 67.75h22a4.25 4.25 0 0 0 4.189-3.532l3-17.5q.06-.356.06-.718V25.5a4.25 4.25 0 1 0-8.5 0v13.75a.25.25 0 1 1-.5 0v-.75a4.25 4.25 0 1 0-8.5 0v.75a.25.25 0 1 1-.5 0v-.75a4.25 4.25 0 1 0-8.5 0v.75a.25.25 0 1 1-.5 0z" clip-rule="evenodd"></path>
				</svg>
			</span>
			`;
	});
};

/* -------------------------------- (SWIPER) -------------------------------- */

// Swiper : Initialisation des sliders
const swiperInit = () => {
	if (
		document.querySelectorAll("#autres-articles .swiper .swiper-slide").length >
		1
	) {
		new Swiper("#autres-articles .swiper", {
			// Core parameters
			slidesPerView: "auto",
			speed: 1200,
			// Modules
			modules: [Scrollbar],
			scrollbar: {
				el: "#autres-articles .swiper-scrollbar",
				draggable: true,
			},
		});
	}
	if ( document.querySelector(".home-swiper") ) {
		new Swiper(".home-swiper", {
			slidesPerView: 1,
			spaceBetween:15,
			speed: 1200,
			modules:[Pagination],
			pagination: {
				el: '.swiper-pagination',
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
			}
		});
	}
	if ( document.querySelector(".watch-swiper") ) {
		new Swiper(".watch-swiper", {
			slidesPerView: 1.5,
			spaceBetween:15,
			breakpoints: {
				768: {
					slidesPerView: 2.5,
				},
				1024: {
					slidesPerView: 3.5,
				},
			},
			loop:1,
			speed: 5000,

			modules:[Autoplay],
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
				pauseOnMouseEnter: false,
			},

			allowTouchMove: false,
		});
	}
};

/* --------------------------------- (GSAP) --------------------------------- */

// GSAP : Initialisation du scrollSmoother (avec ScrollSmoother)
const initScrollSmooth = () => {
	scrollSmooth = ScrollSmoother.create({
		wrapper: "#page-wrapper",
		content: "#page-container",
		smooth: 1,
		smoothTouch: false,
		effects: true,
		normalizeScroll: false,
		ignoreMobileResize: true,
	});
};

// GSAP : Rafraîchissement du ScrollSmoother (avec ScrollSmoother)
const gsapScrollSmootherRefresh = () => {
	if (scrollSmooth) {
		// Désactiver sur Élémentor
		if (document.querySelector("body.elementor-editor-active")) {
			scrollSmooth.kill();
		} else {
			scrollSmooth.refresh();
		}
	}
};

// GSAP : Animations liés au menuBurger
const gsapMenuBurger = () => {
	const burgerTimeline = gsap.timeline();
	burgerTimeline.from(["#page-header .header__fullmenu .menu__item"], {
		duration: 0.6,
		stagger: 0.05,
		ease: "power1.out",
		autoAlpha: 0,
		x: 40,
	});
};

// GSAP : Animations au scroll (avec ScrollTrigger)
const gsapDataAnimation = () => {
	

	// [data-animation] + .elementor-element
	const elementsToAnimated = document.querySelectorAll([
		"#page-container [data-animation]",
		"#page-container .elementor-heading-title",
		"#page-container .elementor-element:not([data-animation]) > .elementor-element",
	]);
	elementsToAnimated.forEach((_this) => {
		const delay = _this.getAttribute("data-animation-delay")
			? parseInt(_this.getAttribute("data-animation-delay"), 10)
			: 0;
		ScrollTrigger.create({
			trigger: _this,
			start: "top 100%",
			end: "bottom 0",
			onEnter: () => {
				setTimeout(() => {
					_this.classList.add("--animated");
				}, delay);
			},
			onLeaveBack: () => {
				_this.classList.remove("--animated");
			},
			// markers: true,
		});
	});

	// data-animation="children-to-top"
	const childrenToTop = document.querySelectorAll(
		"[data-animation='children-to-top']"
	);
	childrenToTop.forEach((_this) => {
		const delay = _this.getAttribute("data-animation-delay")
			? parseInt(_this.getAttribute("data-animation-delay"), 10) / 1000
			: 0;
		gsap.from(_this.children, {
			y: "50%",
			autoAlpha: 0,
			duration: 1.2,
			ease: "power4.out",
			delay: delay,
			stagger: 0.1,
		});
	});

	// data-animation="reveal-text"
	const textsToAnimated = document.querySelectorAll([
		// global
		'#page-container [data-animation="reveal-text"]',
		"#page-container .elementor-element:not([data-animation]) > .elementor-widget-container > .elementor-heading-title",
	]);
	textsToAnimated.forEach((_thisText) => {
		const delay = _thisText.getAttribute("data-animation-delay")
			? parseInt(_thisText.getAttribute("data-animation-delay"), 10) / 1000
			: 0;
		const split = SplitText.create(_thisText, {
			type: "lines, words",
			autoSplit: true,
			mask: "lines",
			onSplit(self) {
				gsap.from(self.words, {
					scrollTrigger: {
						trigger: _thisText,
						start: "top 88%",
						toggleActions: "play none none reverse",
						// markers: true,
					},
					y: "100%",
					autoAlpha: 0,
					delay: delay,
					duration: 0.8,
					ease: "power3.out",
					stagger: 0.05,
				});
			},
		});
	});

	// data-animation="reveal-text-reading"
	const textsToReading = document.querySelectorAll(
		'[data-animation="reveal-text-reading"]'
	);
	textsToReading.forEach((_this) => {
		const delay = _this.getAttribute("data-animation-delay")
			? parseInt(_this.getAttribute("data-animation-delay"), 10) / 1000
			: 0;

		const split = SplitText.create(_this, {
			type: "words, chars",
			onSplit(self) {
				gsap.fromTo(
					self.chars,
					{
						opacity: 0.1,
					},
					{
						opacity: 1,
						delay: delay,
						stagger: 0.4,
						ease: "power1.out",
						scrollTrigger: {
							trigger: _this,
							start: "top 88%",
							end: "top 22%",
							scrub: true,
							// markers: true
						},
					}
				);
			},
		});
	});

	// data-animation="counter"
	const elementsToCounter = document.querySelectorAll(
		'[data-animation="counter"]'
	);
	elementsToCounter.forEach((_this) => {
		const delay = _this.getAttribute("data-animation-delay")
			? parseInt(_this.getAttribute("data-animation-delay"), 10)
			: 0;
		ScrollTrigger.create({
			trigger: _this,
			start: "top 100%",
			end: "bottom 0%",
			// markers: true,
			onEnter: () => {
				setTimeout(() => {
					gsap.from(_this, {
						duration: 1.5,
						textContent: 0,
						snap: { textContent: 1 },
						stagger: {
							each: 1.0,
							onUpdate: function () {
								this.targets()[0].innerHTML = Math.ceil(
									this.targets()[0].textContent
								)
									// conserver les "."
									.toString()
									.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
									// conserver les espaces
									.toString()
									.replace(/\B(?=(\d{3})+(?!\d))/g, "&nbsp;");
							},
						},
					});
				}, delay);
			},
		});
	});

	// data-animation="skid"
	const elementsToskid = document.querySelectorAll([
		'body:not(.elementor-editor-active) [data-animation="skid"]',
	]);
	elementsToskid.forEach((_this) => {
		gsap.to(_this, {
			scrollTrigger: {
				trigger: _this,
				pin: true,
				pinSpacing: false,
				start: "top top",
				// markers: true,
			},
		});
	});

	/*
	// data-animation="draw"
	const elementsToDraw = document.querySelectorAll(['[data-animation="draw"]']);
	elementsToDraw.forEach((_this) => {
		const delay = _this.getAttribute("data-delay")
			? parseInt(_this.getAttribute("data-delay"), 10) / 100
			: 0;
		gsap.from(_this.querySelectorAll("g > *"), {
			drawSVG: 0,
			ease: "power1.inOut",
			duration: 1.2,
			delay: delay,
			scrollTrigger: {
				trigger: _this,
				start: "top 88%",
				// markers: true,
			},
		});
	});
	*/

	/*
	// data-animation="drawing"
	const elementsToDrawing = document.querySelectorAll([
		'[data-animation="drawing"]',
	]);
	elementsToDrawing.forEach((_this) => {
		const delay = _this.getAttribute("data-delay")
			? parseInt(_this.getAttribute("data-delay"), 10) / 100
			: 0;
		gsap.from(_this.querySelectorAll("g > *"), {
			drawSVG: 0,
			ease: "power1.inOut",
			duration: 1.8,
			delay: delay,
			stagger: 0.1,
			scrollTrigger: {
				trigger: _this,
				start: "top 88%",
				end: "bottom 44%",
				scrub: 1.1,
				// markers: true,
			},
		});
	});
	*/

	if ( document.querySelector('.page-home')) {
		// SPLINE ANIMATION
		ScrollTrigger.create({
			trigger: '.hero-page-home',
			start: "top 80%",
			end: "bottom 0",
			onEnterBack: () => {
				spline.setVariables({ position: 0 });
			},
		});
		ScrollTrigger.create({
			trigger: '.home-movement',
			start: "top 80%",
			end: "bottom 0",
			onEnter: () => {
				spline.setVariables({ position: 1 });
			},
			onEnterBack: () => {
				spline.setVariables({ position: 1 });
			},
		});
		ScrollTrigger.create({
			trigger: '.home-signature',
			start: "top 80%",
			end: "bottom 0",
			onEnter: () => {
				spline.setVariables({ position: 2 });
			},
			onEnterBack: () => {
				spline.setVariables({ position: 2 });
				document.querySelector('#canvasWatch').style.display = "block";
			},
			onLeave: () => {
				document.querySelector('#canvasWatch').style.display = "none";
			},
		});
		let homeVideo = document.querySelector('.home-lili-1-video video');
		ScrollTrigger.create({
			trigger: '.home-lili-1-video',
			start: "top 80%",
			end: "bottom 0",
			onEnter: () => {
				homeVideo.play();
			},
			onLeave: () => {
				homeVideo.pause();
			},
			onEnterBack: () => {
				homeVideo.play();
			},
			onLeaveBack: () => {
				homeVideo.pause();
			},
		});
		gsap.to('#canvasWatch', {
			scrollTrigger: {
				trigger: '.home-shape',
				start: "top 80%",
				end: "bottom 0",
				scrub: 1.1,
			},
			opacity: 0,
		});
		
		const hero = document.querySelector('.hero-page-home');
		hero.addEventListener('mousemove', (e) => {
			const rect = hero.getBoundingClientRect();

			const x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
			const y = ((e.clientY - rect.top) / rect.height) * 2 - 1;

			gsap.to(watch.rotation, {
				x: -y * 0.15,
				y: x * 0.1,
				duration: 0.5,
				ease: "power2.out"
			});
		});
		hero.addEventListener('mouseleave', () => {
			gsap.to(watch.rotation, {
				x: 0,
				y: 0,
				duration: 1
			});
		});
	}

	gsap.set('.header__navbar__background', { scaleX: 0, transition:'none', });
	gsap.set('.header__navbar__nav--left .menu__item .menu__link', { x: '100%', transition:'none', });
	gsap.set('.header__navbar__nav--right .menu__item .menu__link', { x: '-100%', transition:'none', });
	gsap.set('.header__navbar__nav--right .menu__item .button span', { x: '-140%', transition:'none', });
	gsap.set('.header__navbar__menu .menu__item .button', { opacity: 0, transition:'none', });


	const menuTimeline = gsap.timeline()
	menuTimeline.fromTo('.header__navbar__background', {
		scaleX: 0,
	}, {
		duration: 1,
		scaleX:1,
		ease: "power4.out",
	})
	.fromTo('.header__navbar__nav--left .menu__item .menu__link', {
		x: '100%',
	}, {
		x: '0%',
		duration: .4,
		stagger: 0.05,
		ease: "power4.out",
	})
	.fromTo('.header__navbar__nav--right .menu__item .menu__link', {
		x: '-100%',
	}, {
		x: '0%',
		duration: .4,
		stagger: 0.05,
		ease: "power4.out",
	},'<=')
	.fromTo('.header__navbar__nav--right .menu__item .button span', {
		x: '-140%',
	}, {
		x: '0%',
		duration: .4,
		stagger: 0.05,
		ease: "power4.out",
	},'<=')
	.fromTo('.header__navbar__menu .menu__item .button', {
		opacity: 0,
	}, {
		opacity:1,
		ease: "power4.out",
	},'<=');
	


	if ( document.querySelector('.accordion')) {
		const items = document.querySelectorAll('.accordion-item');

		items.forEach(item => {
			const header = item.querySelector('.accordion-header');
			const body = item.querySelector('.accordion-body');

			// État initial
			if (item.classList.contains('active')) {
				body.style.maxHeight = body.scrollHeight + 'px';
			}

			header.addEventListener('click', () => {
				const isOpen = item.classList.contains('active');

				if (isOpen) {
					item.classList.remove('active');
					body.style.maxHeight = '0px';
				} else {
					item.classList.add('active');
					body.style.maxHeight = body.scrollHeight + 'px';
				}
			});
		});

		// Recalcule les hauteurs au resize
		window.addEventListener('resize', () => {
			document.querySelectorAll('.accordion-item.active .accordion-body')
			.forEach(body => {
				body.style.maxHeight = body.scrollHeight + 'px';
			});
		});
  	}

	
	const section = document.querySelector(".watch-signature");
	if ( section) {
		const btnDay = section.querySelector(".btn-day");
		const btnNight = section.querySelector(".btn-night");

		btnDay.addEventListener("click", () => {
			section.classList.remove("night");

			btnDay.classList.add("active");
			btnNight.classList.remove("active");
		});


		btnNight.addEventListener("click", () => {
			section.classList.add("night");

			btnNight.classList.add("active");
			btnDay.classList.remove("active");
		});
	}

};

// Actions exécutées après le preLoader d'accueil
const afterPreloader = () => {
	scrollEnabled(true);
	swiperInit();
	gsapDataAnimation();
	scrollToAnchor();
};

// GSAP : Gestion du preloader d'accueil
const gsapPreloader = () => {
	// Chargement des fonctions GSAP préalables
	initScrollSmooth();
	scrollEnabled(false);



	// Lancement de l'animation de chargement
	const loaderTimeline = gsap.timeline();
	loaderTimeline
		// animation
		if ( document.querySelector('.page-home') ) {
			loaderTimeline
			.delay(0.5)
			.to("#page-preloader .preloader__logo .splec-c path", {
				strokeDashoffset: 0,
				duration: 1.2,
				ease: "power1.out",
			})
		}
		loaderTimeline
		.to("#page-preloader .preloader__logo .splec-c path", {
			fill: "white",
			duration: 0.6,
			ease: "power1.out",
			onComplete:()=>{

					if ( document.querySelector('#canvasWatch')) {
						spline.setVariable('start', 1);
					}
			}
		})
		.delay(0.3)
		.to("#page-preloader .preloader__wrapper", {
			duration: 1,
			ease:"power1.out",
			y: "100%",
		})
		.to("#page-preloader .preloader__wrapper .splec-c", {
			duration: 1,
			ease: "power1.out",
			y: "-100vh",
		},'<=')
		.set("#page-preloader", { display: "none" });

	loaderTimeline.add(afterPreloader, loaderTimeline.duration() - 0.3);
};

// SPLINE
import { Application } from '@splinetool/runtime';
let watch, spline;
const loadSpline = async() => {
	if ( document.querySelector('.hero-page-home') ) {
		const canvas = document.getElementById('canvasWatch');
		spline = new Application(canvas);
		await spline.load('https://prod.spline.design/q9O97FkAqsmYXU0E/scene.splinecode');
		watch = spline.findObjectByName('lili-2');

		const observer = new IntersectionObserver(([entry]) => {
			if (entry.isIntersecting) {
				spline.play?.();
			} else {
				spline.stop?.();
			}
		}, {
			threshold: 0
		});

		observer.observe(canvas);
	}
	if ( document.querySelector('.page-single-watches') ) {
		const canvas = document.getElementById('canvasWatchPreview');
		spline = new Application(canvas);
		await spline.load('https://prod.spline.design/9uoxn0ftpkOEFSa5/scene.splinecode');

		const observer = new IntersectionObserver(([entry]) => {
			if (entry.isIntersecting) {
				spline.play?.();
			} else {
				spline.stop?.();
			}
		}, {
			threshold: 0
		});

		observer.observe(canvas);


		const btnDay = document.querySelector('#watch-preview .btn-day');
		const btnNight = document.querySelector('#watch-preview .btn-night');

		btnDay.addEventListener('click', () => {
			spline.setVariable('night', 0);
			btnDay.classList.add('active');
			btnNight.classList.remove('active');
		});

		btnNight.addEventListener('click', () => {
			spline.setVariable('night', 1);

			btnNight.classList.add('active');
			btnDay.classList.remove('active');
		});
	}

}
